/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {KTIcon} from '../../../helpers'
import clsx from 'clsx'
import {useIntl} from 'react-intl'

const HeaderUserMenu: FC = () => {
  const {logout} = useAuth()
  const intl = useIntl()

  return (
    <>
      <a
        href='#'
        className={clsx('btn btn-icon ', 'btn-active-light-primary btn-custom')}
        data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
      >
        <KTIcon iconName='menu' />
      </a>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px'
        data-kt-menu='true'
      >
        <Languages />

        <div className='menu-item px-5 my-1'>
          <Link to='/my-profile' className='menu-link px-5'>
            {' '}
            {intl.formatMessage({id: 'PROFILE.SETTINGS.ACCOUNT'})}{' '}
          </Link>
        </div>
        <div className='menu-item px-5'>
          <a onClick={logout} className='menu-link px-5'>
            {intl.formatMessage({id: 'PROFILE.SETTINGS.LOGOUT'})}
          </a>
        </div>
      </div>
    </>
  )
}

export {HeaderUserMenu}
